import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-[0_-10px_20px_rgba(0,0,0,0.1)] z-50 md:hidden animate-in slide-in-from-bottom-full duration-300" data-id="element-408">
      <div className="flex items-center justify-between gap-4" data-id="element-409">
        <div className="flex flex-col" data-id="element-410">
          <span className="text-xs text-gray-500 line-through" data-id="element-411">$12.90</span>
          <span className="text-2xl font-extrabold text-[#C2410C] leading-none" data-id="element-412">
            $6.39
          </span>
        </div>
        <a href="https://foundationalgut.lat/cart/45663549980774:1" className="flex-1 bg-[#C2410C] text-white py-3 px-4 rounded-lg font-bold text-center flex items-center justify-center gap-2 shadow-lg" data-id="element-413">
          <Download className="w-5 h-5" data-id="element-414" />
          Get It Now
        </a>
      </div>
    </div>;
}